import React, { useState } from 'react';
import { SalvButton, SalvCard, Size } from '@salvapp/ui-components';
import RerunPeriodicScenarioModal from './RerunPeriodicScenarioModal';
import RerunPeriodicScenarioForPeriodModal from './RerunPeriodicScenarioForPeriodModal';
import RerunByPersonIdsModal from './RerunByPersonIdsModal';
import RerunByTxCreatedTimeRangeModal from './RerunByTxCreatedTimeRangeModal';
import RerunByTxIdRangeModal from './RerunByTxIdRangeModal';
import RerunByTxIdsModal from './RerunByTxIdsModal';
import RerunByTxTimestampRangeModal from './RerunByTxTimestampRangeModal';

type ModalType =
  | 'periodicScenario'
  | 'periodicScenarioForPeriod'
  | 'personIds'
  | 'txCreatedTimeRange'
  | 'txIdRange'
  | 'txIds'
  | 'txTimestampRange'
  | null;

const RerunScenariosCard = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);

  const closeModal = () => setActiveModal(null);

  return (
    <>
      <SalvCard expansionOptions={{ isDefaultExpanded: false }}>
        <SalvCard.Header>Rerun Scenarios</SalvCard.Header>
        <SalvCard.Body>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <SalvButton
              onClick={() => setActiveModal('periodicScenario')}
              size={Size.SMALL}
              label='Rerun Periodic Scenario'
              variant={'text'}
            />
            <SalvButton
              onClick={() => setActiveModal('periodicScenarioForPeriod')}
              size={Size.SMALL}
              label='Rerun Periodic Scenario for a Time Period'
              variant={'text'}
            />
            <SalvButton
              onClick={() => setActiveModal('personIds')}
              size={Size.SMALL}
              label='Rerun Scenarios for Persons by IDs'
              variant={'text'}
            />
            <SalvButton
              onClick={() => setActiveModal('txCreatedTimeRange')}
              size={Size.SMALL}
              label='Rerun Scenarios for Transactions by Created Time Range'
              variant={'text'}
            />
            <SalvButton
              onClick={() => setActiveModal('txIdRange')}
              size={Size.SMALL}
              label='Rerun Scenarios for Transactions by ID Range'
              variant={'text'}
            />
            <SalvButton
              onClick={() => setActiveModal('txIds')}
              size={Size.SMALL}
              label='Rerun Scenarios for Transactions by IDs'
              variant={'text'}
            />
            <SalvButton
              onClick={() => setActiveModal('txTimestampRange')}
              size={Size.SMALL}
              label='Rerun Scenarios for Transactions by Timestamp Range'
              variant={'text'}
            />
          </div>
        </SalvCard.Body>
      </SalvCard>

      <RerunPeriodicScenarioModal show={activeModal === 'periodicScenario'} onClose={closeModal} />
      <RerunPeriodicScenarioForPeriodModal show={activeModal === 'periodicScenarioForPeriod'} onClose={closeModal} />
      <RerunByPersonIdsModal show={activeModal === 'personIds'} onClose={closeModal} />
      <RerunByTxCreatedTimeRangeModal show={activeModal === 'txCreatedTimeRange'} onClose={closeModal} />
      <RerunByTxIdRangeModal show={activeModal === 'txIdRange'} onClose={closeModal} />
      <RerunByTxIdsModal show={activeModal === 'txIds'} onClose={closeModal} />
      <RerunByTxTimestampRangeModal show={activeModal === 'txTimestampRange'} onClose={closeModal} />
    </>
  );
};

export default RerunScenariosCard;
